<template>
    <div class="inner">
        <div class="xs-left">
            <div class="chart-con">
                <div class="chart-title">
                    <IconTitle :title="'各领域引文影响力'" :iconName="'yemiankuangjia'"/>
                </div>
                <div class="chart-con-main">
                    <div class="chart" id="chart1"></div>
                </div>
            </div>
            <div class="chart-con">
                <div class="chart-title">
                    <IconTitle :title="'各领域活跃指数'" :iconName="'yemianliu'"/>
                </div>
                <div class="chart-con-main">
                    <div class="chart" id="chart2"></div>
                </div>
            </div>
            <div class="chart-con">
                <div class="chart-title">
                    <IconTitle :title="'中国高被引论文被各国引用情况'" :iconName="'renwuzhongxin'"/>
                </div>
                <div class="chart-con-main">
                    <div class="chart" id="chart3"></div>
                </div>
            </div>
        </div>
        <div class="xs-right">
            <div class="chart-con">
                <div class=" w-50">
                    <div class="chart-title">
                        <IconTitle :title="'各省市论文数量占比'" :iconName="'sandengfen'"/>
                    </div>
                    <div class="chart-con-main">
                        <div class="chart" id="chart4"></div>
                    </div>
                </div>
                <div class="w-50">
                    <div class="chart-title">
                        <IconTitle :title="'各省市被引量占比'" :iconName="'xinzengdaohangliebiao'"/>
                    </div>
                    <div class="chart-con-main">
                        <div class="chart" id="chart5"></div>
                    </div>
                </div>
            </div>
            <div class="chart-con map-chart-con">
                <div class="chart-title">
                    <IconTitle :title="'各省市发文量'" class="lg" :iconName="'wenben'"/>
                </div>
                <div class="chart-con-main">
                    <div class="chart" id="chart6"></div>
                </div>
            </div>
        </div>
        <div class="xs-center">
            <div class="table-con">
                <div class="thead">
                    <dl>
                        <dd v-for="(item,index) of schoolPapersData.title" :key="index">
                            {{ item }}
                        </dd>
                    </dl>
                </div>
                <div class="tbody" ref="estimateList">
                    <div>
                        <dl v-for="(item,index) of schoolPapersData.list" :key="index">
                            <dd v-for="(curr,subIndex) of item" :key="subIndex">
                                {{ curr }}
                            </dd>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    const BASE_FONT_COLOR = '#B5C8FF';
    const LINE_COLOR = '#344ED5';
    const CHART_COLOR = ['#05BDF7', '#FB058F', '#30CF70', '#EF9412'];
    const mapColor = ['#8592FF', '#6978FF', '#4E60F9', '#384DDF', '#293FCA', '#1831B2'];
    import IconTitle from '@/components/icontitle';
    import {
        paperQuoteByForeign,
        gnxsPaperInfluence,
        paperActive,
        paperQuotesScale,
        paperPublishScale,
        paperPublish,
        schoolPapers
    } from '@/assets/scripts/api/xsdt';
    export default {
        name: 'GuoNeiXueShu',
        components: {
            IconTitle
        },
        data(){
            return {
                // 被国外引用数据
                paperQuoteByForeignData: {},
                // 论文影响力
                paperInfluenceData: {},
                // 引用情况
                paperActiveData: {},
                // 地图数据
                paperPublishData: {},
                // 各省市论文数量占比
                paperQuotesScaleData: {},
                // 各省市被引量占比
                paperPublishScaleData: {},
                // 国内高校论文发文量排行
                schoolPapersData: {
                    list: [],
                    title: []
                }
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async getChartInitData(){
                let {data: paperQuoteByForeignData} = await paperQuoteByForeign();
                let {data: paperInfluenceData} = await gnxsPaperInfluence();
                let {data: paperActiveData} = await paperActive();
                let {data: paperPublishData} = await paperPublish();
                let {data: schoolPapersData} = await schoolPapers();

                this.paperQuoteByForeignData = paperQuoteByForeignData;
                this.paperInfluenceData = paperInfluenceData;
                this.paperActiveData = paperActiveData;
                this.paperPublishData = paperPublishData;
                this.schoolPapersData = schoolPapersData;

                this.$nextTick(() => {
                    this.$scrollTable(this.$refs.estimateList);
                });
            },
            async init() {
                await this.getChartInitData();
                this.initChart1();
                this.initChart2();
                this.initChart3();
                this.initChart6();
                this.getPaperReactData();
            },
            initRadarCharts(data, type, maxNum = 80) {
                let indicatorData = [];
                let radarData = [];


                for (let {name, value} of data) {
                    indicatorData.push({name,max:type < 2 ? 2 : maxNum});
                    radarData.push(parseFloat(value));
                }
                const option = {
                    tooltip: {
                        position: ['50%', '0%'],
                        formatter: function(params) {
                            let data = params.value,
                                str = '';

                            data.forEach((item,index) => {
                                str += indicatorData[index].name + ' : ' +item +'<br>';
                            })

                            return str;
                        }
                    },
                    radar: {
                        splitNumber: 2,
                        axisLine: {
                            lineStyle: {
                                color: LINE_COLOR
                            }
                        },
                        splitArea: false,
                        splitLine: {
                            lineStyle: {
                                color: LINE_COLOR
                            }
                        },
                        name: {
                            textStyle: {
                                color: BASE_FONT_COLOR,
                                padding: [3, 5]
                            }
                        },
                        indicator: indicatorData
                    },
                    series: [{
                        type: 'radar',
                        data: [{
                            value: radarData,
                            name: ''
                        }],
                        symbolSize: 8,
                        lineStyle: {
                            color: CHART_COLOR[type]
                        },
                        areaStyle: {
                            color: CHART_COLOR[type],
                            opacity: 0.5
                        },
                        itemStyle: {
                            color: CHART_COLOR[type],
                            borderWidth: 2
                        }

                    }]
                };
                return option;
            },
            initChart1() {
                const chart = echarts.init(document.getElementById("chart1"));

                chart.setOption(this.initRadarCharts(this.paperInfluenceData, 0), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart2() {
                const chart = echarts.init(document.getElementById("chart2"));
                chart.setOption(this.initRadarCharts(this.paperActiveData, 1), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart3() {
                const chart = echarts.init(document.getElementById("chart3"));
                const {column, list, title} = this.paperQuoteByForeignData;
                let seriesData = [];
                const baseSeriesOpt = {
                    // name: '中国',
                    type: 'line',
                    stack: '',
                    smooth: true,
                    itemStyle: {
                        color: CHART_COLOR[0],
                        borderWidth: borderW
                    },
                    symbol: 'circle',
                }
                list.map((item, index) => {
                    seriesData.push(Object.assign({}, baseSeriesOpt, {
                        name: title[index],
                        itemStyle: {color: CHART_COLOR[index]},
                        data: list[index].map((item) => parseFloat(item))
                    }));
                });
                const borderW = 4;
                const option = {
                    tooltip: {
                        trigger: 'axis',
                        position: ['50%', '0%'],
                    },
                    legend: {
                        data: title,
                        textStyle: {
                            color: BASE_FONT_COLOR
                        },
                        icon: "circle",
                        itemWidth: 6,
                        bottom: 0
                    },
                    grid: {
                        left: '0',
                        right: 0,
                        top: 10,
                        bottom: '50',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        color: BASE_FONT_COLOR,
                        axisLabel: {
                            color: BASE_FONT_COLOR
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#2F46C1'
                            }
                        },
                        axisTick: {
                            alignWithLabel: 20
                        },
                        data: column
                    },
                    yAxis: {
                        type: "value",
                        axisLabel: {
                            color: BASE_FONT_COLOR,
                            formatter: "{value}%"
                        },
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: LINE_COLOR
                            }
                        },
                        nameTextStyle: {
                            color: BASE_FONT_COLOR
                        }
                    },
                    series: seriesData
                };

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            async getPaperReactData(areaCode = 110000){
                let {data: paperQuotesScaleData} = await paperQuotesScale({area_code: areaCode});
                let {data: paperPublishScaleData} = await paperPublishScale({area_code: areaCode});

                this.paperQuotesScaleData = paperQuotesScaleData.map((item) => {
                    item.value = parseFloat(item.value);
                    return item
                });
                this.paperPublishScaleData = paperPublishScaleData.map((item) => {
                    item.value = parseFloat(item.value);
                    return item
                });
                this.initChart4();
                this.initChart5();
            },
            initChart4() {
                const chart = echarts.init(document.getElementById("chart4"));
                let paperData = this.paperPublishScaleData;
                let max = paperData[0]['value'];

                for (let i = 0; i < paperData.length - 1; i++) {
                    max = max < paperData[i+1]['value'] ? paperData[i+1]['value'] : max
                }
                chart.setOption(this.initRadarCharts(this.paperPublishScaleData, 2,max), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart5() {
                const chart = echarts.init(document.getElementById("chart5"));

                let paperData = this.paperQuotesScaleData;
                let max = paperData[0]['value'];
                for (let i = 0; i < paperData.length - 1; i++) {
                    max = max < paperData[i+1]['value'] ? paperData[i+1]['value'] : max
                }
                chart.setOption(this.initRadarCharts(this.paperQuotesScaleData, 3,max), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart6() {
                const chart = echarts.init(document.getElementById("chart6"));
                let min = 0, max = 0;

                const chinaMapData = this.paperPublishData.map(item => {
                    item.value = item.Heat;
                    if (item.value > max) {
                        max = item.value;
                    }
                    if (item.value < min) {
                        min = item.value;
                    }
                    return item;
                });

                const mapOpts = {
                    tooltip: {
                        trigger: 'item',
                        formatter: ({name, value = 0}) => {
                            return `${name}<br>${isNaN(value) ? 0 : value}`
                        }
                    },
                    geo: {
                        show: true,
                        map: 'china',
                        zoom: 1,
                        label: {
                            emphasis: {
                                show: false
                            }
                        },
                        itemStyle: {
                            normal: {
                                borderColor: '#090D28',
                                borderWidth: 1,
                                areaColor: '#8592FF',
                                shadowColor: 'rgba(133,146,255,.3)',
                                shadowBlur: 50
                            },
                            emphasis: {
                                areaColor: '#4E60F9'
                            }
                        }
                    },
                    visualMap: {
                        textStyle: {
                            color: '#FFF'
                        },
                        realtime: false,
                        left: 20,
                        min: min,
                        max: max,
                        bottom: 20,
                        itemWidth: 15,
                        itemHeight: 100,
                        calculable: false,
                        show: false,
                        inRange: {
                            color: mapColor
                        }
                    },
                    series: [{
                        type: 'map',
                        geoIndex: 0,
                        data: chinaMapData
                    }]
                };

                chart.setOption(mapOpts);
                chart.resize();
                chart.on("click", ({data}) => {
                    if (!data) {
                        return false;
                    }

                    let {id} = data;
                    this.getPaperReactData(id);
                })
                this.$winResize(chart.resize);

            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "@/assets/scss/mixins/_variables";

    .inner {
        color: $primary-text-color;
        font-size: 0.19rem;
        padding: 0 2.08%;

        .xs {

            &-left,
            &-right,
            &-center {
                height: 100%;
            }

            &-left {
                float: left;
                width: 19.84375%;

                .chart-con {
                    height: 33.33%;

                    // .chart {
                    //     height: 85.284%;
                    // }
                }
            }

            &-center {
                margin-left: 21.927%;
                margin-right: 43.28125%;
                .table-con {
                    height: 100%;
                    overflow: hidden;
                }

                dl {
                    width: 100%;
                    font-size: 0.16rem;
                    border: 1px solid $table-border-color;
                    text-align: center;
                    font-weight: 400;
                    height: 0.5rem;
                    overflow: hidden;
                    &:nth-of-type(7n+2) {
                        text-align: left;
                    }

                    dd {
                        float: left;
                        height: 0.5rem;
                        line-height: 0.5rem;
                        text-align: center;

                        &:first-child {
                            width: 10%;
                        }

                        &:nth-child(2) {
                            width: 15%;
                        }

                        &:nth-child(3) {
                            width: 15%;
                        }
                        &:nth-child(4) {
                            width: 15%;
                        }
                        &:nth-child(5) {
                            width: 10%;
                        }
                        &:nth-child(6) {
                            width: 15%;
                        }
                    }

                }

                .thead dl {
                    font-size: 0.14rem;
                    background-color: $second-bg-color;

                }

                .tbody {
                    height: calc(100% - .5rem);
                    overflow: hidden;

                    dl {
                        &:nth-of-type(odd) {
                            background-color: $primary-bg-color
                        }

                        &:nth-of-type(even) {
                            background-color: $second-bg-color;
                        }
                    }
                }

            }

            &-right {
                float: right;
                width: 41.198%;

                .chart-con {
                    height: 33.33%;

                    &.map-chart-con {
                        height: 66.66%;
                        background: no-repeat center/cover;
                        // background-image: url("~@/assets/images/decoration-big.png");
                    }

                    // .chart {
                    //     height: 100%;
                    //     margin-bottom: -0.4rem;
                    // }
                }

                .w-50 {
                    width: 48.16%;
                    height: 100%;

                    // .chart {
                    //     height: 85.284%;
                    // }

                    display: inline-block;

                    &:first-child {
                        margin-right: 3%;
                    }
                }
            }
        }

        .chart-con {
            height: 33.33%;
            overflow: hidden;
            .chart-title {
                margin-bottom: 0.2rem;
            }

            &.map-chart-con {
                height: 66.66%;
                background: no-repeat center/cover;
                // background-image: url("~@/assets/images/decoration-big.png");
            }

            .chart-con-main {
                height: calc(100% - 0.8rem);

                .chart {
                    height: 100%;
                    // margin-top: 0.8rem;
                }
            }
        }
    }
</style>